import { urlsConfig } from 'src/configs';
import { TSocketMessageType } from 'src/types/mixed.type';

let socket: WebSocket | undefined;

let heartbeatTimer: number | undefined = undefined;
const HEARTBEAT_INTERVAL_MS = 30_000;

window.addEventListener('unload', function () {
  if (socket && socket.readyState === WebSocket.OPEN) socket.close();
});

function startHeartbeat() {
  stopHeartbeat();
  heartbeatTimer = window.setInterval(() => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({ type: 'keepalive', t: Date.now() }));
    }
  }, HEARTBEAT_INTERVAL_MS);
}

function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = undefined;
  }
}

export const createConnection = (socketCallback: (socketStatus: boolean) => void) => {
  if (socket === undefined || socket.readyState === WebSocket.CLOSED) {
    socket = new WebSocket(urlsConfig.hymotsEUrl);

    socket.onerror = () => {
      socketCallback(false);
    };

    socket.onopen = () => {
      socketCallback(true);
      startHeartbeat();
    };

    socket.onclose = (ev: CloseEvent) => {
      if (ev.reason !== 'reconnect') {
        stopHeartbeat();
        socketCallback(false);

        setTimeout(() => {
          createConnection(socketCallback);
        }, 2000);
      }
    };
  }
};

export const listenSocket = (callback: (event: any) => void) => {
  if (socket) {
    socket.onmessage = callback;
  }
};

export const sendMessage = (message: any, isJSON: boolean = true) => {
  setTimeout(() => {
    if (socket) {
      if (isJSON) {
        socket.send(JSON.stringify(message));
      } else {
        socket.send(message);
      }
    }
  }, 1000);
};

export const connectionRequest = (gameId: number, eventId: string) => {
  const msg: TSocketMessageType = {
    mesajTipi: 1,
    mesajAltTipi: 1,
    icerik: {
      istemciTipi: 5,
      uygulamaSekli: 2, // Mock for now
      tur: 1,
      emirAliciTipi: 1,
      emirIcerigi: {},
      emirId: -1,
      icraEdecekEtmenId: -1,
      icraZamani: 0,
      icraZamaniTipi: 1,
      kontrolTipi: -1,
      istemciEtmenId: -1,
      userRole: '6c741fa4-fbec-4b3d-917b-4721f38d1839',
      eventId: eventId,
    },
    oyunId: gameId || 0,
  };

  sendMessage(msg);
};

export const closeSocketConnection = (gameId: number) => {
  const msgStop: TSocketMessageType = {
    mesajTipi: 1,
    mesajAltTipi: 10,
    icerik: {
      istemciTipi: 5,
      uygulamaSekli: 2, // Mock for now
      tur: 1,
      emirAliciTipi: 1,
      emirIcerigi: {},
      emirId: -1,
      icraEdecekEtmenId: -1,
      icraZamani: 0,
      icraZamaniTipi: 1,
      kontrolTipi: -1,
      istemciEtmenId: -1,
      userRole: '6c741fa4-fbec-4b3d-917b-4721f38d1839',
    },
    oyunId: gameId || 0,
  };
  sendMessage(msgStop);
  try {
    socket?.close(1000, 'manual-close');
  } catch (error) {}
  socket = undefined;
};
